import { hoc } from 'src/core/utils';
import { useTryZynProps } from './try-zyn.props';
import { Header, HowBlock, Form, ProductsList } from './components';
import { UserAge } from './components';

/**
 * <TryZyn />
 */

const TryZyn = hoc(useTryZynProps, ({ isAgeGate, setIsAgeGate }) => (
  <div>
    <Header />
    <Form />
    <HowBlock />
    <ProductsList />
    {!isAgeGate && <UserAge setIsAgeGate={setIsAgeGate} />}
  </div>
));

export { TryZyn };
